// extracted by mini-css-extract-plugin
export default {"separator-style":"breadcrumb_separator-style__VGfXl"};